import { questionsMinorWorks } from "../../api/blawksAPI"

const BOOLEAN = "boolean"
const DATE = "date"

const getAttribute = (attribute, attributes) => attributes.find(item => item.Attribute == attribute)
 
export const getDropdownOptions = (attributeType, objects) => {
    
    const options = []

    switch (attributeType) {
        case BOOLEAN:
            options.push(
                { id: 1, label: "True", value: "true" },
                { id: 2, label: "False", value: "false" }
            )
            break;
        default:
            options.push(
                { id: 1, label: "True", value: "true" },
                { id: 2, label: "False", value: "false" }
            )
            break;
            // const objectOptions = objects.filter(obj => obj.Category == attributeType)
            // objectOptions.forEach((option, index) => {
            //     options.push(
            //         { id: index, label: option.Object, value: option.Object }
            //     )
            // })
            
    }

    return options
}

export const formatAttributeNLG = (question, attribute) => {
    switch (attribute.Type) {
        case BOOLEAN:
            return 'Is it ' + 'true/false ' + question.Prefix + ' ' + question.Postfix + '?'
        case 'navigable_water':
            return  'Is it true/false the navigable water ' + question.Infix + ' ' + question.Prefix + '?'
        case 'work':
            return  'Is it true/false ' + question.Prefix + ' ' + question.Infix + '?'
        default:
            return attribute.Type + ' ' + question.Infix + ' ' + question.Prefix + ' ' + attribute.Category
    }

}

export const mapNLGQuestions = (nlgQuestions, attributes, objects) => {
    const questions = []

    nlgQuestions.forEach(question => {
        const attribute = getAttribute(question.Attribute, attributes)
        const attributeType = attribute.Type
        const questionText = questionsMinorWorks.find(item => item.attribute === question.Attribute) ? questionsMinorWorks.find(item => item.attribute === question.Attribute).question : formatAttributeNLG(question, attribute)
        questions.push(
            {
                questionText,
                options: getDropdownOptions(attributeType, objects),
                attribute: attribute,
            }
        )
    })

    return questions
}

export const testResultNames = [
    {
        id:'CNWA_definition_navigable_water', 
        result_name: 'Navigable Waters', 
        result_positive: 'The body of water is likely a Navigable Water', 
        explanation_hard_coded: 
        <>
        <h1>Reason 1 </h1>
        <p>
        We know it holds that according to section 1_2__subsection 3, body_of_water is a navigable water because
        <ul>
        <li>according to section 1_2__subsection 3, body_of_water is a navigable water and</li>
        <li>there is no evidence that the conclusion in section 1_2__subsection 3 that body_of_water is a navigable water is defeated.</li>
        </ul>
        </p>
        We know body_of_water is a body of water, which was provided as a fact.
        <p>
        There is no evidence that the conclusion in section 1_2__subsection 3 that body_of_water is a navigable water is defeated because
        <ul>
        <li>there is no evidence that it holds that it is false that according to section 1_2_01, it is not true that body_of_water is a navigable water.</li>
        </ul>
        There is no evidence that it holds that it is false that according to section 1_2_01, it is not true that body_of_water is a navigable water because
        <ul>
        <li>there is no evidence that according to section 1_2_01, it is not true that it is not true that body_of_water is a navigable water.</li>
        </ul>
        There is no evidence that according to section 1_2_01, it is not true that it is not true that body_of_water is a navigable water because
        <ul>
        <li>body_of_water is a body of water and</li>
        <li>there is no evidence that body of water body_of_water is an artificial irrigation channel or drainage ditch.</li>
        <li>There is no evidence that body of water body_of_water is an artificial irrigation channel or drainage ditch.</li>
        </ul>
        </p>
        <h1>Reason 2</h1>
        <p>
        We know it holds that according to section 1_2__subsection 3, body_of_water is a navigable water because
        <ul>
        <li>according to section 1_2__subsection 3, body_of_water is a navigable water and</li>
        <li>there is no evidence that the conclusion in section 1_2__subsection 3 that body_of_water is a navigable water is defeated.</li>
        </ul>

        We know according to section 1_2__subsection 3, body_of_water is a navigable water because
        <ul>
        <li>body_of_water is a body of water body of water body_of_water is used or has a reasonable likelihood to be used by vessels and</li>
        <li>body of water body_of_water meets navigable water definition paragraph criteria.</li>
        </ul>
        </p>
        We know body of water body_of_water is used or has a reasonable likelihood to be used by vessels, which was provided as a fact.
        <p>
        We know body of water body_of_water meets navigable water definition paragraph criteria because
        <ul>
        <li>it holds that according to section 1_2__subsection 3 paragraph c, body of water body_of_water meets navigable water definition paragraph criteria.</li>
        </ul>
        We know it holds that according to section 1_2__subsection 3 paragraph c, body of water body_of_water meets navigable water definition paragraph criteria because
        <ul>
        <li>according to section 1_2__subsection 3 paragraph c, body of water body_of_water meets navigable water definition paragraph criteria.</li>
        </ul>
        We know according to section 1_2__subsection 3 paragraph c, body of water body_of_water meets navigable water definition paragraph criteria because
        <ul>
        <li>body_of_water is a body of water and</li>
        <li>body of water body_of_water has Her Majesty in right of Canada or a province as the only riparian owner.</li>
        </ul>
        </p>

        We know body of water body_of_water has Her Majesty in right of Canada or a province as the only riparian owner, which was provided as a fact.

        <p>
        
        There is no evidence that the conclusion in section 1_2__subsection 3 that body_of_water is a navigable water is defeated because
        <ul>
        <li>there is no evidence that it holds that it is false that according to section 1_2_01, it is not true that body_of_water is a navigable water.</li>
        </ul>
        There is no evidence that it holds that it is false that according to section 1_2_01, it is not true that body_of_water is a navigable water because
        <ul>
        <li>there is no evidence that according to section 1_2_01, it is not true that it is not true that body_of_water is a navigable water.</li>
        </ul>
        There is no evidence that according to section 1_2_01, it is not true that it is not true that body_of_water is a navigable water because
        <ul>
        <li>body_of_water is a body of water and</li>
        <li>there is no evidence that body of water body_of_water is an artificial irrigation channel or drainage ditch.</li>
        <li>There is no evidence that body of water body_of_water is an artificial irrigation channel or drainage ditch.</li>
        </ul>
        </p>
        </>,
        result_negative: 'The body of water is not a Navigable Water'
    },
{id:'CNWA_definition_minor_work', result_name: 'Minor Work', result_positive: 'The work is likely a Minor Work', result_negative: 'The work is likely not a Minor Work',
explanation_hard_coded: 
<>
<h1>Reason 1 </h1>
Where:
<ul>
<li>A is equal to B plus C</li>
<li>D is less than or equal to 5</li>
<li>E is less than or equal to</li>
<li>F is not work</li>
</ul>
<p>We know it holds that according to section 1_2__subsection 2, work is a minor work because
according to section 1_2__subsection 2, work is a minor work.</p>
We know according to section 1_2__subsection 2, work is a minor work because
<ul>
<li>
work is a work and</li>
<li>work work is designated as a minor work through a regulation made under paragraph 28(2)(a) of the CNWA.</li>
</ul>
<p>
We know work work is designated as a minor work through a regulation made under paragraph 28(2)(a) of the CNWA because
it holds that according to section 2_3__subsection 1 paragraph a, work work is designated as a minor work through a regulation made under paragraph 28(2)(a) of the CNWA.
</p>
<p>
We know it holds that according to section 2_3__subsection 1 paragraph a, work work is designated as a minor work through a regulation made under paragraph 28(2)(a) of the CNWA because
according to section 2_3__subsection 1 paragraph a, work work is designated as a minor work through a regulation made under paragraph 28(2)(a) of the CNWA.
</p>

We know according to section 2_3__subsection 1 paragraph a, work work is designated as a minor work through a regulation made under paragraph 28(2)(a) of the CNWA because
<ul>
<li>work is a work and</li>
<li>work work is an erosion-protection work refereed to in subsection 12(1) of the Minor Works Order.</li>
</ul>
We know work work is an erosion-protection work refereed to in subsection 12(1) of the Minor Works Order because
<ul>
<li>
it holds that according to section 2_12__subsection 1, work work is an erosion-protection work refereed to in subsection 12(1) of the Minor Works Order.
</li>
</ul>

We know it holds that according to section 2_12__subsection 1, work work is an erosion-protection work refereed to in subsection 12(1) of the Minor Works Order because
<ul>
<li>
according to section 2_12__subsection 1, work work is an erosion-protection work refereed to in subsection 12(1) of the Minor Works Order.
</li>
</ul>
We know according to section 2_12__subsection 1, work work is an erosion-protection work refereed to in subsection 12(1) of the Minor Works Order because
<ul>
<li>
work is a work
</li>
<li>work work is an erosion protection work</li>
<li>according to section 2_12__subsection 1 paragraph a, work work meets the respective criteria for this rule section</li>
<li>according to section 2_12__subsection 1 paragraph b, work work meets the respective criteria for this rule section</li>
<li>according to section 2_12__subsection 1 paragraph c, work work meets the respective criteria for this rule section</li>
<li>according to section 2_12__subsection 1 paragraph d, work work meets the respective criteria for this rule section</li>
<li>according to section 2_12__subsection 1 paragraph e, work work meets the respective criteria for this rule section and</li>
<li>according to section 2_12__subsection 1 paragraph f, work work meets the respective criteria for this rule section.</li>
<li>We know work work is an erosion protection work, which was provided as a fact.</li>
</ul>

We know according to section 2_12__subsection 1 paragraph a, work work meets the respective criteria for this rule section because
<ul>
<li>work is a work and</li>
<li>work work is integrated with and follows the bank of the navigable water.</li>
<li>We know work work is integrated with and follows the bank of the navigable water, which was provided as a fact.</li>
</ul>
We know according to section 2_12__subsection 1 paragraph b, work work meets the respective criteria for this rule section because
<ul>
<li>work is a work</li>
<li>body of water is a navigable water</li>
<li>the submerged part of work extends horizontally B metres into navigable water navigable_water </li>
<li>the nonsubmerged part of work extends horizontally A metres into navigable water navigable_water  and</li>
<li>there is no evidence that B is greater than A.</li>
<li>We know the submerged part of work extends horizontally B metres into navigable water navigable_water , which was provided as a fact.</li>
<li>There is no evidence that B is greater than A.</li>
</ul>
We know according to section 2_12__subsection 1 paragraph c, work work meets the respective criteria for this rule section because
<ul>
<li>work is a work</li>
<li>work work extends D metres into the navigable water and</li>
<li>D is less than or equal to 5.</li>
<li>We know work work extends D metres into the navigable water, which was provided as a fact.</li>
<li>We know D is less than or equal to 5, which was provided as a fact.</li>
</ul>
We know according to section 2_12__subsection 1 paragraph d, work work meets the respective criteria for this rule section because

<ul>
<li>
work is a work</li>
<li>body of water is a navigable water</li>
<li>work work occupies E metres of the width of navigable water navigable_water </li>
<li>navigable water navigable_water is 20 metres wide at the location of work work  and</li>
<li>(anything / 20) is less than or equal to .</li>
<li>We know work work occupies E metres of the width of navigable water navigable_water , which was provided as a fact.</li>
<li>We know navigable water navigable_water is 20 metres wide at the location of work work , which was provided as a fact.</li>
<li>We know (anything / 20) is less than or equal to , which was provided as a fact.</li>
</ul>
We know ccording to section 2_12__subsection 1 paragraph e, work work meets the respective criteria for this rule section because
<ul>
<li>work is a work and</li>
<li>there is no evidence that work work is associated with a non minor work.</li>
</ul>
There is no evidence that work work is associated with a non minor work because

<ul>
<li>work is a work</li>
<li>there is no evidence that F is a work and</li>
<li>there is no evidence that work work is associated with other work work .</li>
<li>There is no evidence that F is a work.</li>
</ul>
There is no evidence that work work is associated with other work work .

We know according to section 2_12__subsection 1 paragraph f, work work meets the respective criteria for this rule section because
<ul>
<li>work is a work and</li>
<li>there is no evidence that work work includes groynes or other structures to deflect the current.</li>
<li>There is no evidence that work work includes groynes or other structures to deflect the current.</li>
</ul>
</>
},
{id:'CNWA_definition_major_work', result_name: 'Major Work', result_positive: 'The work is likely a Major Work', result_negative: 'The work is likely not a Major Work'},
{id: 'CNWA_s3_defeated', result_name: 'Probation', result_positive: 'The work likely does need a probation period', result_negative: 'The work likely does not need probation period'}
]